module.exports = __webpack_public_path__ + "1811e93f25a521cdd6c13a7f8c8eeb68.svg";